<template>
    <el-dialog v-model="dialogShow" title="导入句子" width="800px" top="100px" :before-close="handleClose" destroy-on-close>

        <div class="inrect vh-flex" v-loading="showLoading">
            <textarea v-model="text" class="vh-full edit" placeholder="请输入句子，每个句子占一行,可用=号分割译文和音标"></textarea>
            <div class="vbot">
                <div>
                    <div class="focus-s">如何包含译文和音标？</div>
                </div>
                <div class="vc-flex">
                    <div @click="selectButton(false)" class="focus-s">取消</div>
                     <div @click="saveClick" class="bnt-import focus-s">开始导入</div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import SaveButton from '@/components/SaveButton.vue'
import httpClient from '@/commom/http/httpClient'
export default {
    name: 'ImportSentenceDialog',
    components: {
        SaveButton
    },
    props: {
        show: Boolean,
        bookId: {
            type:String,
            default:""
        },
        unitId: {
            type:String,
            default:""
        }
    },
    watch: {
        show: function (nval, old) {
            this.text = ""
            this.dialogShow = nval
        },

    },
    data() {
        return {
            dialogShow: this.showDialog,
            text:"",
            showLoading:false
        }
    },
    methods: {
        handleClose: function () {
            this.selectButton(false)
        },
        ///选择按钮
        selectButton: function (result, data) {
            var res = {
                confrim: result,
                data: data
            }
            this.$emit("selectButton", res)
        },
        saveClick: function (result) {
            var text = this.text.trim()
            if(text==""){
                this.$message({message:"请输入句子"})
                return
            }
            if(this.bookId=="" || this.unitId==""){
                this.$message({message:"未知错误"})
                return
            }

            var req = {
                bookId:this.bookId,
                unitId:this.unitId,
                content:text
            }
            var that = this
            that.showLoading = true
            httpClient.invoke("UnitSentenceAPI.ImportSentence",req,function(res){
                that.showLoading = false
                if(res.error){
                    that.$message({message:res.error})
                    return
                }
                that.$message.success("导入成功")
            
                that.selectButton(true)
            })

        },

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bnt-import{
    background: var(--ek-color-primary);
    color: white;
    padding-left: 30px;
    padding-right: 30px;
    line-height: 35px;
    border-radius: 10px;
    margin-left: 30px;
}
.vbot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
}

.edit {
    resize: none;
    background: var(--ek-input-backColor);
    font-size: 15px;
    font-family: sans-serif;
    border: none;
    outline: none;
    padding: 10px;
    border-radius: 5px;
    color: var(--ek-text-color1);
}

.inrect {
    height: 600px;
    padding-top: 0px;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 15px;
}
</style>